import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PalantirTextComponent } from '../text/text.component';

@Component({
  selector: 'palantir-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [PalantirTextComponent],
})
export class PalantirRadioComponent {
  @Input() public label?: string;
}
